var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tx-pair-info" }, [
    _c(
      "div",
      {
        staticClass: "token-img",
        on: {
          click: function($event) {
            return _vm._showDetail("token")
          }
        }
      },
      [
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.ftokenIcon,
              expression: "ftokenIcon"
            }
          ],
          attrs: { src: _vm.ftokenIcon }
        }),
        _vm._v(" "),
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeTxPairIsClose,
              expression: "activeTxPairIsClose"
            }
          ],
          staticClass: "close"
        })
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "t-item" }, [
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isCMC,
              expression: "isCMC"
            }
          ],
          staticClass: "cmc-img",
          on: { click: _vm.gotoCMC }
        },
        [
          _c("tooltips", {
            staticClass: "tips",
            attrs: { content: _vm.$t("tradeCenter.cmcHelp") }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "symbol",
          on: {
            click: function($event) {
              return _vm._showDetail("token")
            }
          }
        },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm.ftokenDetail ? _vm.ftokenDetail.symbol : "") +
              "\n        "
          )
        ]
      ),
      _vm._v(" /\n        "),
      _c(
        "span",
        {
          staticClass: "symbol ttoken",
          on: {
            click: function($event) {
              return _vm._showDetail("token")
            }
          }
        },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm.ttokenDetail ? _vm.ttokenDetail.symbol : "") +
              "\n        "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "zero-fee-icon" },
        [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isZeroFee,
                expression: "isZeroFee"
              }
            ],
            attrs: { src: require("assets/imgs/trade/zero_fee.svg") }
          }),
          _vm._v(" "),
          _c("tooltips", {
            staticClass: "tips",
            attrs: { content: _vm.$t("tradeCenter.zeroFee") }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: +_vm.isMining,
              expression: "+isMining"
            }
          ],
          staticClass: "mining"
        },
        [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isMining === 1,
                expression: "isMining === 1"
              }
            ],
            attrs: { src: require("assets/imgs/trade_mining.svg") }
          }),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isMining === 2,
                expression: "isMining === 2"
              }
            ],
            attrs: { src: require("assets/imgs/order_mining.svg") }
          }),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isMining === 3,
                expression: "isMining === 3"
              }
            ],
            attrs: { src: require("assets/imgs/mining.svg") }
          }),
          _vm._v(
            "\n            " +
              _vm._s(_vm.orderMiningMultiples) +
              "\n            "
          ),
          _c("tooltips", {
            staticClass: "tips",
            attrs: { content: _vm.supportMining }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "gate",
          on: {
            click: function($event) {
              return _vm._showDetail("operator")
            }
          }
        },
        [
          _c("img", {
            staticClass: "gate-img",
            attrs: { src: _vm.operatorIcon }
          }),
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.operatorInfo
                  ? _vm.operatorInfo.name
                  : _vm.$t("tradeCenter.operator.noName")
              ) +
              "\n        "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }